/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type GetTransactionDetailResponseStatus = typeof GetTransactionDetailResponseStatus[keyof typeof GetTransactionDetailResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionDetailResponseStatus = {
  pending: 'pending',
  success: 'success',
  void: 'void',
} as const;
